module.exports = __webpack_public_path__ + "static/Charlotte-5af965d2691fbce4e6b9745880057246.png";